import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'DetailsForm',
  mixins: [ActionsForm],
  components: {HeadDetailsGama},
  props: ['selectedComissao']

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/detailsforms/detailsforms.js